const joi = require('joi');

const schema = joi.object({
  username: joi.string()
    .min(4)
    .max(20)
    .required(),
  password: joi.string()
    .required(),
}).options({ abortEarly: false, stripUnknown: true });

export default schema;
